import { render } from "./QuestionFormSingleAnswer.vue?vue&type=template&id=d738b610&scoped=true&ts=true"
import script from "./QuestionFormSingleAnswer.vue?vue&type=script&lang=ts"
export * from "./QuestionFormSingleAnswer.vue?vue&type=script&lang=ts"

import "./QuestionFormSingleAnswer.vue?vue&type=style&index=0&id=d738b610&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d738b610"]])

export default __exports__